import type { Strings } from "../state.js";

export interface MuteButtonProps {
  muted: boolean;
  strings: Strings;
  onToggle(): void;
}

export function MuteButton({ muted, strings, onToggle }: MuteButtonProps) {
  return (
    <button
      type="button"
      class="va-mute-button"
      data-muted={String(muted)}
      aria-pressed={muted}
      aria-label={muted ? strings.unmute : strings.mute}
      onClick={onToggle}
    >
      {muted ? strings.unmute : strings.mute}
    </button>
  );
}
